import { SettingInfo } from '../../class/state-manager';

export interface ChatMessage {
  type: 'ai' | 'user';
  message: string;
  partModelUuids: string[];
  setting: Array<SettingInfo>;
}

export interface AutoPrompt {
  prompt: string;
  next: string;
}

export const AUTO_PROMPTS: { [key: string]: AutoPrompt[] } = {
  first: [
    {
      prompt: '私の予算は千万ウォンだよ。 アグレッシブなスタイルのリアスポイラーをおすすめして。',
      next: 'end',
    },
    {
      prompt: 'あなたはどんな製品を販売しているの？',
      next: 'selectedPart',
    },
  ],
  selectedPart: [
    {
      prompt: 'MPスタイル カーボンフロントスポイラー',
      next: 'end',
    },
    {
      prompt: 'MPスタイル カーボンリアフェンダーアーチトリム',
      next: 'end',
    },
    {
      prompt: 'MPスタイル カーボンリアバンパーインサート',
      next: 'end',
    },
  ],
  end: [{ prompt: 'うん、見せて', next: 'first' }],
};
